module.exports = __webpack_public_path__ + "static/media/retrospect_response.354524fe.png";